export default "__VITE_ASSET__DsktV4SO__"